// src/components/HospitalityFooter.jsx
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { getTranslation } from "../utils/translations";
import { Link } from "react-router-dom";
import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaTelegram,
  FaXTwitter,
  FaEnvelope,
  FaPhone,
} from "react-icons/fa6";

export default function HospitalityFooter() {
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const { lang } = useContext(LanguageContext);
  const t = getTranslation(lang);
  return (
    <footer style={footerStyle}>
      <div style={containerStyle}>

        {/* Contact Info */}
        <div>
          <h4 style={sectionTitleStyle}>{t.hospitality_footer?.contact_us}</h4>
          <p style={contactItemStyle}>
            <FaEnvelope color="#D44638" />{" "}
            <span style={{ color: "#D44638", fontWeight: "bold" }}>{t.hospitality_footer?.email}:</span>{" "}
            <span>ispotera.2026@gmail.com</span>
          </p>
          <p style={contactItemStyle}>
            <FaPhone color="#2563EB" />{" "}
            <span style={{ color: "#2563EB", fontWeight: "bold" }}>{t.hospitality_footer?.phone}:</span>{" "}
            <span>+49 176 614 55380</span>
          </p>
          <p style={contactItemStyle}>
            <FaWhatsapp color="#25D366" />{" "}
            <span style={{ color: "#25D366", fontWeight: "bold" }}>
              {t.hospitality_footer?.whatsapp}:
            </span>{" "}
            <span>+49 176 614 55380</span>
          </p>
          <p style={contactItemStyle}>
            <FaTelegram color="#0088cc" />{" "}
            <span style={{ color: "#0088cc", fontWeight: "bold" }}>{t.hospitality_footer?.telegram}:</span>{" "}
            <span>+49 176 614 55380</span>
          </p>
        </div>

        {/* Social Media */}
        <div>
          <h4 style={sectionTitleStyle}>{t.hospitality_footer?.follow_us}</h4>
          <div style={socialIconsStyle}>
            <a
              href="https://www.facebook.com/profile.php?id=100015268721337"
              target="_blank"
              rel="noopener noreferrer"
              style={iconStyle}
            >
              <FaFacebook />
            </a>
            <a
              href="https://instagram.com/ispotera_2026"
              target="_blank"
              rel="noopener noreferrer"
              style={iconStyle}
            >
              <FaInstagram />
            </a>
            <a
              href="https://t.me/ispotera_official"
              target="_blank"
              rel="noopener noreferrer"
              style={iconStyle}
            >
              <FaTelegram />
            </a>
            <a
              href="https://x.com/ispotera"
              target="_blank"
              rel="noopener noreferrer"
              style={iconStyle}
            >
              <FaXTwitter />
            </a>
          </div>
        </div>
      </div>


      {/* Navigation Links */}
      <div style={navLinksStyle}>
        <Link to="/" style={linkStyle}>{t.hospitality_footer?.home}</Link> |{" "}
        {currentUser?.admin ? (
          <Link to="/admin" style={linkStyle}>{t.hospitality_footer?.admin_panel}</Link>
        ) : (
          <span style={{ ...linkStyle, cursor: "not-allowed", opacity: 0.5 }}>
            {t.hospitality_footer?.admin_panel}
          </span>
        )}
      </div>

      {/* Bottom Bar */}
      <div style={bottomBarStyle}>
        © {new Date().getFullYear()} iSpotera. {t.hospitality_footer?.rights_reserved}
      </div>
    </footer>

  );
}

/* ------------------- Styles ------------------- */
const footerStyle = {
  backgroundColor: "#1c1917",
  color: "#e7e5e4",
  padding: "30px 20px",
  marginTop: "50px",
};

const containerStyle = {
  maxWidth: "1200px",
  margin: "0 auto",
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  gap: "30px",
};

const brandTitleStyle = {
  marginBottom: "12px",
  color: "#ff33cc",
  fontSize: "1.6rem",
};

const brandDescStyle = {
  fontSize: "1rem",
  lineHeight: 1.7,
  color: "#d6d3d1",
};

const sectionTitleStyle = {
  marginBottom: "10px",
  color: "#f97316",
  fontSize: "1.1rem",
};

const contactItemStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginBottom: "8px",
  fontSize: "0.95rem",
};

const linkStyle = {
  color: "#f97316",
  textDecoration: "none",
};

const socialIconsStyle = {
  display: "flex",
  gap: "15px",
  fontSize: "1.4rem",
};

const iconStyle = {
  color: "#e7e5e4",
  textDecoration: "none",
};

const bottomBarStyle = {
  borderTop: "1px solid #44403c",
  marginTop: "35px",
  paddingTop: "15px",
  textAlign: "center",
  fontSize: "0.85rem",
  color: "#d6d3d1",
  fontWeight: "bold",
};

const navLinksStyle = {
  textAlign: "center",
  marginTop: "20px",
  marginBottom: "10px",
  fontSize: "1rem",
};
